<template>
  <div id="data-list-checklists" class="data-list-container">

    <checklist-item-data-view @createChecklist="createChecklist" @updateChecklist="updateChecklist" :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="checklists">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Acões</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Deletar</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="CopyIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Copiar</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Cadastrar</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ checklists.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : checklists.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">ID#</vs-th>
        <vs-th sort-key="name">Nome</vs-th>
        <vs-th sort-key="type">Tipo</vs-th>
        <vs-th>Acões</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.id ? tr.id : 'N/A' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ fixType(tr.type) }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
              <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteConfirm(tr.id)" />
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ChecklistItemDataView from './ChecklistItemDataView.vue'
import moduleDataList from '@/store/data-list/moduleDataList.js'

export default {
  components: {
    ChecklistItemDataView
  },
  data () {
    return {
      selected: [],
      checklists: [],
      itemsPerPage: 4,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      toBeDeleted: null
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.checklists.length
    }
  },
  methods: {
    fixType (type) {
      if (type === 'pictureUrl') return 'Foto'
      if (type === 'date') return 'Data'
      if (type === 'check') return 'Verificação'
      if (type === 'text') return 'Texto descrição'
    },
    fixDate (date) {
      const receivedTime = new Date(date)
      const receivedYear = receivedTime.getFullYear()
      const receivedMonth = receivedTime.getMonth()
      const receivedDay = receivedTime.getDate()
      return `${receivedDay}/${receivedMonth + 1}/${receivedYear}`
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    deleteConfirm (id) {
      this.toBeDeleted = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Deseja mesmo remover esse Item?',
        text: 'Ao confirmar esta operação este Item não será mais visível.',
        accept: this.deleteData
      })
    },
    async deleteData () {
      try {
        this.$vs.loading()
        await this.$http.delete(
          `/api/v1/admin/company/checks/${this.toBeDeleted}`,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Item removido',
          text: 'Item removido com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
        this.getChecklists()
      } catch (err) {
        console.log(err)
        this.$vs.notify({
          title: 'Erro na Remocão',
          text: 'Não foi possível remover item',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.toBeDeleted = null
        this.$vs.loading.close()
      }         
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold')   return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled')  return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90)  return 'success'
      if (num > 70)  return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50)  return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    async createChecklist (data) {
      try {
        this.$vs.loading()
        await this.$http.post(
          '/api/v1/admin/company/checks',
          data,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Item criado',
          text: 'Item criado com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
        this.getChecklists()
      } catch (err) {
        console.log(err)
        this.$vs.notify({
          title: 'Erro na Criação',
          text: 'Não foi possível criar Item',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }      
    },
    async updateChecklist (data) {
      try {
        console.log(data.data)
        this.$vs.loading()
        await this.$http.put(
          `/api/v1/admin/company/checks/${data.id}`,
          data.body,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Item atualizado',
          text: 'Item atualizado com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
        this.getChecklists()
      } catch (err) {
        console.log(err)
        this.$vs.notify({
          title: 'Erro na Atualização',
          text: 'Não foi possível atualizar o item',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }      
    },
    async getChecklists () {
      try {
        this.$vs.loading()
        const response = await this.$http.get(
          '/api/v1/admin/company/checks',
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.checklists = response.data
      } catch (err) {
        console.log(err)
      } finally {
        this.$vs.loading.close()
      }
    }
  },
  created () {
    if (!moduleDataList.isRegistered) {
      this.$store.registerModule('dataList', moduleDataList)
      moduleDataList.isRegistered = true
    }
    this.getChecklists()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-checklists {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
